export default "__VITE_ASSET__880f4164__"